import Modal from '@maison/components/common/Modal';
import { get } from 'lodash-es';
import { closeModal } from '@phoenix/helpers/modal-helper';

export default {
  components: { Modal },

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  methods: {
    setSubmitButtonLoading(loading) {
      if (loading) {
        Toolkit.helpers.buttons.addLoadingState(this.$refs.submitButton);
      } else {
        Toolkit.helpers.buttons.removeLoadingState(this.$refs.submitButton);
      }
    },

    close() {
      closeModal(this.id);
    },

    getModalProps(event) {
      return event instanceof Event ? JSON.parse(get(event, 'target.dataset.modalProps', '{}')) : event;
    },
  },
};
